import atob from "atob";
import btoa from "btoa";
import dateformat from 'dateformat';
import ThumbnailFarm from "./ThumbnailFarm"
import CDN from "../CDN"


const FsPattern = new RegExp(/^([a-z])([k-t]+)([0-9]+\.[^/]+)$/);
const CfuPattern = new RegExp(/^([0-9a-f]{13})([0-9a-zA-Z])([0-9a-zA-Z])(_?)(\.[^.]+)?(\.thumb)?$/);
const UploadFarmPattern = new RegExp(/cfile\d*\.uf@(\w+)(\.\w*)?/);
const TenthPagePattern = new RegExp(/t\/([0-9]+)@(\w+)/);
const TenthCfilePattern = new RegExp(/t\/([a-z]+)@(\w+)/);
const KagePattern = new RegExp(/kage@(\S+)/);

const FsUrlPattern = new RegExp(/http:\/\/cfs\d+\.tistory\.com\/upload_control\/download.blog\?fhandle=(\S+)/);
const FsFhandlePattern = new RegExp(/\w+@fs(\d+)\.tistory\.com:\/attach\/(\w)\/(\S+)/);
const CfuUrlPattern = new RegExp(/http:\/\/cfs(\d+).tistory.com\/(\w+)\/(\d+)\/tistory\/(\d{4}\/\d{2}\/\d{2}\/\d{2}\/\d{2})\/([0-9a-f]{13})/);
const CfileUrlPattern = new RegExp(/https?:\/\/t1\.daumcdn\.net\/cfile\/(\w+)\/(\w+)/);
const TenthPageUrlPattern = new RegExp(/https?:\/\/\S+\.daumcdn\.net\/\S+\/(\S+)\/attach\/(\w+)/);
const KageUrlPattern = new RegExp(/https?:\/\/\S*\.kakaocdn\.net\/dn\/(\S*)\/(\w+\.\w+)/);

const UploadFarmUrlPattern = new RegExp(/http:\/\/cfile([0-9]+)\.uf\.([a-z]+\.[a-z]+)\/[^/]*\/([0-9A-F]+)(\.[^.]+)?/)

const ImageExt = ['.jpeg', '.gif', '.png', '.bmp', '.jpg'];

const CFU_DICTIONARY = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

function strtr(str, from, to) {
  let i, ch, length = str.length;
  let result = '';
  for (i = 0 ; i < length ; i++) {
    ch = str[i];
    result += to[from.indexOf(ch)]
  }
  return result;
}

function cfileNumToServicePath(host, cfileNum) {
  if (host === 'tistory.com') {
    return '/tistory'
  } else if (cfileNum > 240) {
    return '/cafe'
  } else if (cfileNum > 200) {
    return '/blog'
  } else {
    return ''
  }
}

function cfileKeyToTenthKey(cfileKey) {
  return cfileKey.substring(0, cfileKey.length - 4)
}

class AttachmentUrlConverter {
  static toTistory(url) {
    if (KageUrlPattern.test(url)) {
      return url.replace(KageUrlPattern, (match, kageKey, filename) => `kage@${kageKey}/${filename}`);
    }

    if (CfileUrlPattern.test(url)) {
      return url.replace(CfileUrlPattern, (match, service, hash) => {
        if (service == 'tistory') {
          return `t/cfile@${hash}`
        } else {
          return `t/${service}@${hash}`
        }
      })
    }

    if (TenthPageUrlPattern.test(url)) {
      return url.replace(TenthPageUrlPattern, (match, blogId, hash) => {
        return `t/${blogId}@${hash}`
      })
    }

    if (CfuUrlPattern.test(url)) {
      return url.replace(CfuUrlPattern, (match, host, type, disk, path, id) => {
        const hostEncoded = CFU_DICTIONARY[host - 1];
        const diskEncoded = CFU_DICTIONARY[disk - 1];
        return `${id}${hostEncoded}${diskEncoded}.png`;
      })
    }

    if (FsUrlPattern.test(url)) {
      return url.replace(FsUrlPattern, (match, fhandle) => {
        const decodedFhandle = atob(decodeURIComponent(fhandle))
        return decodedFhandle.replace(FsFhandlePattern, (match, index, fileKey, filename) => {
          const ch1 = String.fromCharCode(parseInt(index) + 97)
          const ch2 = strtr(fileKey, '0123456789', 'klmnopqrst')
          return `${ch1}${ch2}${filename}`
        })
      })
    }

    return url;
  }

  static toUrl(key) {
    if (KagePattern.test(key)) {
      return key.replace(KagePattern, (match, key) => `https://blog.kakaocdn.net/dn/${key}`)
    }

    if (UploadFarmPattern.test(key)) {
      return key.replace(UploadFarmPattern, (match, key, ext) => {
        return `https://t1.daumcdn.net/cfile/${appInfo.service}/${key.substring(0, key.length - 4)}`
      })
    }

    if (TenthCfilePattern.test(key)) {
      return key.replace(TenthCfilePattern, (match, service, tenthKey) => {
        const cfileService = service === 'cfile'? 'tistory' : service
        return `https://t1.daumcdn.net/cfile/${cfileService}/${tenthKey}`
      })
    }

    if (TenthPagePattern.test(key)) {
      return key.replace(TenthPagePattern, (match, blogId, tenthKey) => {
        return CDN.getBlogUrl(`/${blogId}/attach/${tenthKey}`)
      })
    }

    if (CfuPattern.test(key)) {
      return key.replace(CfuPattern, (match, id, host, disk, originalFlag, ext, thumbnailFlag) => {
        const hostDecoded = CFU_DICTIONARY.indexOf(host) + 1;
        const diskDecoded = CFU_DICTIONARY.indexOf(disk) + 1;
        const path = dateformat(new Date((parseInt(id.substr(0, 8), 16) + 3600 * 9) * 1000), 'yyyy/mm/dd/HH/MM', true);

        return `http://cfs${hostDecoded}.tistory.com/image/${diskDecoded}/tistory/${path}/${id}`;
      });
    }

    if (FsPattern.test(key)) {
      return key.replace(FsPattern, (match, p1, p2, p3) => {
        const index = p1.charCodeAt() - 97
        const handle = encodeURIComponent(btoa(`blog${Config.blog.blogSettings.blogId}@fs${index}.tistory.com:/attach/${strtr(p2,'klmnopqrst', '0123456789')}/${p3}`))
        return `http://cfs${index}.tistory.com/upload_control/download.blog?fhandle=${handle}`;
      })
    }

    return key
  }

  static isUfImage(key) {
    const matched = key.match(UploadFarmPattern)
    if (matched) {
      return matched[2] !== undefined && ImageExt.indexOf(matched[2].toLowerCase()) > 0
    }

    return true
  }

  static ufToTenthUrl(url) {
    return url.replace(UploadFarmUrlPattern, (match, cfileNum, host, cfileKey) => {
      const servicePath = cfileNumToServicePath(host, cfileNum)
      const key = cfileKeyToTenthKey(cfileKey)
      return `https://t1.daumcdn.net/cfile${servicePath}/${key}`
    })
  }

  static toContentThumbnail(url) {
    return ThumbnailFarm.to('R1280x0', url)
  }
}

export default AttachmentUrlConverter
